<template>
    <div style="height: 100%;" v-loading="loading">
        <div class="header" style="display: flex; align-items: center; justify-content: space-between; height: 60px; border-bottom: solid 1px lightgray; background-color: #4570c7; color: white;">
            <router-link to="/invite">
                <div style="width: 44px; margin: 0 16px;">
                    <i class="fas fa-user-plus"></i>
                </div>
            </router-link>
            <div style="font-size: 17px; margin: 8px 16px; width: 100%; text-align: center;">
                {{ getTitle() }}
            </div>
            <div style="margin: 8px 0; display: flex; align-items: center;">
                <el-dropdown trigger="click">
                    <span class="el-dropdown-link">
                        <div style="display: flex; align-items: center; color: white; width: 44px; height: 100%; text-align: center; align-items: center;">
                            <i class="fas fa-ellipsis-v" style="margin: 0 auto; width: 32px; cursor: pointer;"></i>
                        </div>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="reloadWindow()">Refresh</el-dropdown-item>
                        <el-dropdown-item @click.native="$router.push('/invite')">Invite</el-dropdown-item>
                        <el-dropdown-item divided @click.native="handleLogout">Logout</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <div v-if="errorMessage" style="color: red; margin-top: 10px auto;">
            {{errorMessage}}
        </div>
        <div v-if="projects && projects.length == 0" style="height: 100%;">
            <div style="display: flex; flex-direction: column; justify-content: center; width: 90%; margin: 0 auto; height: 100%; text-align: center; align-items: center;">
                <img :src="'/img/empty_projects.svg'" width="300" style="margin: 0 auto;">
                <div style="margin: 32px; font-weight: 700; text-align: center;">
                    Let's create your first project
                </div>
                <router-link to="/projects/new" style="width: 100%;">
                    <el-button type="primary" style="width: 100%;">Create project</el-button>
                </router-link>
            </div>
        </div>
        <div v-else-if="loading">
        </div>
        <div v-else>
            <el-card class="box-card" style="max-width: 600px; margin: 0 auto; width: 100%;">
                <router-link to="/projects/new" v-if="$route.path == '/projects'">
                    <div style="text-align: center;margin-right: 16px; background-color: white; color: rgb(69, 112, 199); border: 1px solid #4570c7; border-radius: 4px; padding: 8px 16px; width: 100%;">
                        Create project
                    </div>
                </router-link>
                <hr style="margin-top: 32px;">
                <div style="margin-top: 0px;">
                    <projects-list-item v-for="project in projects" :project="project"></projects-list-item>
                </div>
            </el-card>
        </div>
    </div>
</template>
<script>
import auth from '@/auth'
import axios from 'axios'
import ProjectsListItem from '@/components/projects/ProjectsListItem'
export default {
    components: {
        ProjectsListItem
    },
    data() {
        return {
            type: 'projects',
            loading: false,
            projects: null,
            currentUser: null,
            errorMessage: null
        }
    },
    mounted() {
        this.$store.dispatch('users/loadById', { id: 'me' }).then(response => {
            this.currentUser = response;
        });
        if (this.$route.params.inviteCode) {
            this.loading = true;
            let filter = { filter: { is_deleted: false } };
            axios.post('/accept_invite', { invite_code: this.$route.params.inviteCode })
                .then(response => {
                    localStorage.token = response.data.access_token;
                    window.location.href = '/';
                }).catch(error => {
                    this.errorMessage = 'An error occured'
                    console.log(error);
                    this.loading = false;
                });
        } else {
            this.loading = true;
            let filter = { filter: { is_deleted: false }, options: { 'page[size]': '100'} };
            this.$store.dispatch('projects/loadWhere', filter).then(() => {
                    this.projects = this.$store.getters[`${this.type}/where`](filter);
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    },
    methods: {
        getTitle() {
            return this.currentUser ? this.currentUser.attributes.company_name : 'Projects Map Manager'
        },
        reloadWindow() {
            window.location.reload(true);
        },
        handleLogout() {
            auth.logout();
        }
    }
}
</script>